<template>
  <footer id="container">
<!--    <div class="blogroll">-->
<!--      <img-->
<!--        class="blogrollImg"-->
<!--        v-for="(item,index) in friendlyLinks"-->
<!--        :key="index"-->
<!--        :src="item.img"-->
<!--        alt="友情链接"-->
<!--        @click="toUrl(item.url)"-->
<!--      >-->
<!--    </div>-->
    <div class="left-right-image-info-title">
      <div class="left-info-boxs">
        <div class="copyright">
          <span>布瑞克（苏州）农业互联网股份有限公司</span>
          <span v-if="hostnameBack === 'www.16988.com'">Copyright◎布瑞克农业控股（北京）有限公司</span>
          <span v-else-if="hostnameBack === 'www.16988.com.cn'">Copyright◎布瑞克（苏州）农业互联网股份有限公司</span>
          <span v-else>Copyright◎布瑞克农业控股（北京）有限公司</span>
          <span>www.16988.com All right sreserved</span>
        </div>
        <div class="copyright">
          <span>版权所有备案：</span>
          <a href="https://beian.miit.gov.cn/" target="__blank" v-if="hostnameBack === 'www.16988.com'"><span>京ICP备11021666号-9</span></a>
          <a href="https://beian.miit.gov.cn/" target="__blank" v-else-if="hostnameBack === 'www.16988.com.cn'"><span class="white">苏ICP备16002944号-1</span></a>
          <a href="https://beian.miit.gov.cn/" target="__blank" v-else><span>京ICP备11021666号-9</span></a>
          <span>客服热线：400-16988-01  0512-66830008  0512-65716709</span>
          <span>邮箱：wuyk@accfutures.com</span>
        </div>
        <div class="copyright">
          <span>友情链接：</span>
          <span class="url-span" @click="toUrl('http://www.malingshuyun.com/')">滕州马铃薯云</span>
          <span class="url-span" @click="toUrl('https://ynhtyun.com/')">云南核桃云</span>
          <span class="url-span" @click="toUrl('https://huangniuyun.com/')">延边黄牛云</span>
          <span class="url-span" @click="toUrl('http://www.douyeyun.com/')">豆业云</span>
        </div>
        <div class="copyright">
          企业荣誉：2020年教字商务企业2018年电子商务示范企业2018年全国大宗商品电商企业百强2018年中国B2B供应链全融创新大奖
        </div>
        <div class="copyright">
          2020年苏州市民营企业百强 2018-2020年苏州独角兽”培育企业2019年苏州市十佳农业创新企业苏州市级农业产业化龙头企业
        </div>
      </div>
      <div class="right-code-images">
        <div class="top-title-code-text">关注我们</div>
        <div class="bot-code-image">
          <div class="content-image">
            <div class="top-image-icon">
              <img src="../../assets/gongzhong-icon.png"
                   style="width: 100px; height: 100px;">
            </div>
            <div class="image-text">官方公众号</div>
          </div>
          <div class="content-image">
            <div class="top-image-icon">
              <img src="../../assets/allite-icon.png"
                   style="width: 100px; height: 100px;">
            </div>
            <div class="image-text">微信小程序</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {getIndexfriendlyLinks} from '@/api/PersonalCenter';

export default {
  name: 'Footer',
  data () {
    return {
      hostnameBack: '',
      friendlyLinks: [
        {img: 'https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/files/16190930544753.png', url: 'http://chinabric.com/'},
        {img: 'https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/files/16190929999818.png', url: 'http://www.agdata.cn/'},
        {
          img: 'https://bric-jgw.oss-cn-hangzhou.aliyuncs.com/files/15640175534764.png',
          url: 'https://www.nongmuren.com/'
        }
      ],
    };
  },
  created () {
    this.hostnameBack = location.hostname;
  },
  methods: {
    async init () {
      let res = await getIndexfriendlyLinks({isShow: 1});
      this.friendlyLinks = res.data.records.map((i) => {
        return {
          url: i.linkHref,
          img: i.linkPic
        };
      });
    },
    toUrl (v) {
      if (v) {
        if (!v.includes('http')) {
          v = 'https://' + v;
        }
        window.open(v, '_blank');//在新页面打开该链接
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/*****************************底 部 开 始*****************************/
.white {
  color: #FFFFFF;
  cursor: pointer;
}

#container {
  width: 100%;
  background: #2C2C2C;
  padding: 27px;
  display: flex;
  flex-direction: column;

  .blogroll {
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 21px;

    .blogrollImg {
      width: 120px;
      height: 42px;
      background-color: #fff;
      border-radius: 4px;
      margin-left: 8px;
      cursor: pointer;

      &:first-child {
        margin-left: 10px;
      }
    }
  }

  .left-right-image-info-title {
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    margin-top: 40px;
    .left-info-boxs {
      flex: 1;
      .copyright {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 13px;
        .url-span{
          cursor: pointer;
        }
        a{
          color: #FFFFFF;
        }

        &:first-child {
          margin-top: 0;
        }
      }
    }

    .right-code-images {
      .top-title-code-text{
        font-size: 18px;
        font-weight: 600;
        color: #FFFFFF;
      }
      .bot-code-image{
        display: flex;
        margin-top: 14px;
        .content-image{
          .image-text{
            text-align: center;
            margin-top: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
          }
          &:last-child{
            margin-left: 40px;
          }
        }
      }
    }
  }
}

/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue